import React from "react";

const PurchaseVipPlan = (props) => {
  return (
    <table className="table table-striped mt-5">
      <thead>
        <tr>
          <th>No.</th>
          <th>User Name</th>
          <th>Dollar</th>
          <th>PHP</th>
          <th>Validity</th>
          <th>Amount Paid</th>
          <th>Payment Gateway</th>
          <th>Purchase Date</th>
        </tr>
      </thead>
      <tbody>
        {props.data?.length > 0 ? (
          props.data.map((data, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{data.name}</td>
                <td className="text-primary">{data.dollar ?? "-"}</td>
                <td className="text-info">{data.php ?? "-"}</td>
                <td>{data.validityLabel || "-"}</td>
                <td>
                  {data.paidAmount != null
                    ? `${data.paidAmount} ${data.paidCurrency || ""}`.trim()
                    : "-"}
                </td>
                <td className="text-success">{data.paymentGateway}</td>
                <td>{new Date(data.purchaseDate).toLocaleString()}</td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="8" align="center">
              Nothing to show!!
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default PurchaseVipPlan;
